import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class RefundModel extends BaseAPIModel {
    static listUrl({ organizationId, eventId, orderId }) {
        if (!organizationId || !eventId || !orderId) {
            throw new ArgumentError(`[Model][RefundModel][getAll] organizationId, eventId and orderId are mandatory`);
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/orders/${orderId}/refunds`;
    }
}
